import CalendarEquipment from './CalendarEquipment';

export default CalendarEquipment;
